import React from 'react';
import { Button, Form, Input, Select, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import dict from '@/script/dict.mjs';
import { useIsLicensed, Unlicensed } from '@/biz/license.jsx'

// 创建对象
const ProjectData = () => {

};

// 编辑
ProjectData.prjNo = () => {
    const rules = [
        {
            required: true,
            message: '请输入项目编号',
        },
        {
            max: 50,
            message: '最长50位',
        },
    ];

    return (
        <Form.Item name="prjNo" rules={rules} label="项目编号">
            <Input size="middle" placeholder="请输入项目编号" />
        </Form.Item>
    );
}

ProjectData.prjName = () => {
    const rules = [
        {
            required: true,
            message: '请输入项目名称',
        },
        {
            max: 50,
            message: '最长50位',
        },
    ];

    return (
        <Form.Item name="prjName" rules={rules} label="项目名称">
            <Input size="middle" placeholder="请输入项目名称" />
        </Form.Item>
    );
}

ProjectData.bVer = () => {
    const rules = [
        {
            required: true,
            message: '请输入版本号',
        },
        {
            max: 50,
            message: '最长50位',
        },
    ];

    return (
        <Form.Item name="bVer" rules={rules} label="版本号">
            <Input size="middle" placeholder="请输入版本号" />
        </Form.Item>
    );
}

ProjectData.prjTarget = () => {
    const rules = [
        {
            required: true,
            message: '请输入项目目标',
        },
    ];

    return (
        <Form.Item name="prjTarget" rules={rules} label="项目目标">
            <Input.TextArea placeholder="请输入项目目标" rows="4" />
        </Form.Item>
    );
}

ProjectData.prjTypeCode = ({ isAdmin, ...props }) => {
    const isLicensed = useIsLicensed();

    const rules = [
        {
            required: true,
            message: '请选择项目类型',
        },
    ];

    return (
        <Form.Item name="prjTypeCode" rules={rules} label="项目类型">
            <Select placeholder="请选择项目类型" {...props}>
                {
                    dict.getDictDtls('PRJ_TYPE')
                        .filter(item => undefined == item.licenseCode || isLicensed(item.licenseCode))
                        .map(item => {
                            return <Option value={item.code}>{item.nameCn}</Option>
                        })
                }
            </Select>
        </Form.Item>
    );
}

ProjectData.subTypeCode = ({ isAdmin, prjType, ...props }) => {
    const rules = [
        {
            required: true,
            message: '请选择项目子类型',
        },
    ];

    let typeList = [];

    if ('NEW' == prjType) {
        typeList = dict.getDictDtls('PRJ_SUB_TYPE');
    } else if ('KM' == prjType) {
        typeList = dict.getDictDtls('KM_SUB_TYPE');
    }

    return (
        <Form.Item name="subTypeCode" rules={rules} label="项目子类型">
            <Select placeholder="请选择项目子类型" {...props}>
                {
                    typeList.map(item => <Option value={item.code}>{item.nameCn}</Option>)
                }
            </Select>
        </Form.Item>
    );
}


ProjectData.desgAcc = ({ isAdmin, ...props }) => {
    return (
        <Form.Item name="desgAcc" label="模型精度">
            <Select placeholder="请选择模型精度" {...props}>
                <Option value="SF_LVL">目标级</Option>
                <Option value="ALG_LVL">算法级</Option>
                <Option value="FC_LVL">程序级</Option>
            </Select>
        </Form.Item>
    );
}

ProjectData.prjStsCode = () => {
    const rules = [
        {
            required: true,
            message: '请选择项目状态',
        },
    ];

    return (
        <Form.Item name="prjStsCode" rules={rules} label="项目状态">
            <Select placeholder="请选择">
                <Option value="DRAFT">草稿</Option>
                <Option value="RLS">发布</Option>
                <Option value="END">结案</Option>
            </Select>
        </Form.Item>
    );
}

ProjectData.SaveButton = ({ onCancel, onSave }) => {
    return (
        <Space>
            <Button size="middle" onClick={onCancel}>取消</Button>
            <Button htmlType="submit" type="primary" size="middle" icon={<SaveOutlined />} onClick={onSave}>保存</Button>
        </Space>
    );
}

export default ProjectData;